import router from './router';
import store from './store';


const whiteList = ['/login', '/', '/interviewRegistration']

router.beforeEach((to, from, next) => {
  let userInfo = sessionStorage.getItem('userInfo') || ''
  if (userInfo) {
    /* has token*/
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      if (store && store.state.permission.routes.length === 0) {
        // 判断当前用户是否已拉取完user_info信息
        // 拉取user_info
        const roles = {}
        // return
        store.dispatch('GenerateRoutes', { roles }).then(accessRoutes => {
          // 测试 默认静态页面
          // store.dispatch('permission/generateRoutes', { roles }).then(accessRoutes => {
          // 根据roles权限生成可访问的路由表
          router.addRoutes(accessRoutes) // 动态添加可访问路由表
          next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
          store.dispatch('user/SET_USERINFO', JSON.parse(userInfo))
        })

      } else {
        if (to.matched.length === 0) {
          next('*')
        } else {

          next()
        }
        // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
        // if (hasPermission(store.getters.roles, to.meta.roles)) {
        //   next()
        // } else {
        //   next({ path: '/401', replace: true, query: { noGoBack: true }})
        // }
        // 可删 ↑
      }
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login`) // 否则全部重定向到登录页
    }
  }
})

